import { Injectable, inject } from '@angular/core';
import {
  ClientServiceCreateRequest,
  ClientServiceCreateResponse,
  ClientServiceCreateResponseSchema,
  ClientServiceGetResponseSchema,
  ClientServiceListRequest,
  ClientServiceUpdateRequest,
  ClientServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectClient } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class ClientRepositoryService implements ApiRepositoryService<
  ClientServiceCreateRequest,
  ClientServiceUpdateRequest,
  ClientServiceListRequest,
  ClientServiceCreateResponse
> {
  private api = inject(ConnectClient);

  create(
    data: ClientServiceCreateRequest,
  ): Observable<ClientServiceCreateResponse> {
    return this.api.create(data).pipe();
  }

  delete(uuid: string): Observable<void> {
    return this.api.delete({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  fetch(uuid: string): Observable<ClientServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            ClientServiceGetResponseSchema,
            ClientServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: ClientServiceListRequest,
  ): Observable<ApiPaginated<ClientServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(data: any): Observable<ClientServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            ClientServiceUpdateResponseSchema,
            ClientServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }
}
